@if (isImpersonating) {
  <div class="fixed top-0 left-0 right-0 bg-amber-500 text-white text-center py-1.5 px-4 z-[9999] flex items-center justify-center gap-3 text-sm font-medium shadow-md">
    <i class="fa-solid fa-user-secret"></i>
    <span>Viewing as client — impersonation mode</span>
    <button (click)="returnToAdmin()"
            class="bg-white text-amber-700 px-3 py-0.5 rounded font-semibold text-xs hover:bg-amber-50 transition-colors cursor-pointer border-0">
      Return to Admin
    </button>
  </div>
}

@if (loadingData.visible) {
  <div class="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
    <i class="fa fa-spinner fa-spin text-4xl text-white"></i>
  </div>
}

<app-toast-container />
<app-confirm-dialog />

<app-tooltip></app-tooltip>

<app-attention-modal [(visible)]="attentionData.visible"
    [message]="attentionData.message"
    [messageHtml]="attentionData.messageHtml"
    [blocking]="attentionData.blocking"
    [isAlert]="attentionData.isAlert"
    [buttonText]="attentionData.buttonText"
    (onHidden)="handleAttentionHidden()"
    (onClicked)="handleAttention($event)"
    (onDismissed)="handleAttentionDismissed()">
</app-attention-modal>

<app-confirm-modal [(visible)]="confirmData.visible"
    [message]="confirmData.message"
    [bigIcon]="confirmData.bigIcon"
    [confirmBtnText]="confirmData.confirmBtnText"
    [cancelBtnText]="confirmData.cancelBtnText"
    [textCenter]="false"
    [loadingData]="loadingData"
    [height]="confirmData.includeFiles ? 648 : 548"
    [width]="confirmData.includeFiles ? 500 : 448"
    (onConfirm)="handleConfirmed($event)">
    @if (confirmData.includeSubject) {
      <div class="field w-full mt-5">
        <div class="field-label">Subject
          <span class="required">(*)</span>:
        </div>
        <div class="field-value">
          <input type="text" class="sz-input" [(ngModel)]="confirmData.subject"
                 placeholder="Please input subject" required />
          @if (!confirmData.subject) {
            <p class="sz-form-error">Subject is required</p>
          }
        </div>
      </div>
    }
    @if (confirmData.includeNote) {
      <app-text-area-historical
        [(value)]="confirmData.note"
        [height]="'h-[150px]'"
        [maxLength]="500"
        [placeholder]="'Please input note'"
        [label]="'Note'"
        [hasLabel]="true"
        [readOnly]="false"
        [isMandatory]="false"
        [showCharacterCount]="true"
        class="w-full mt-5"
      ></app-text-area-historical>
    }
    @if (confirmData.includeReasonDropdown) {
      <div class="field w-full mt-5">
        <div class="field-label">Reason
          <span class="required">(*)</span>:
        </div>
        <div class="field-value">
          <select class="sz-input" [(ngModel)]="confirmData.selectedReason">
            <option value="">-- Select a reason --</option>
            @for (option of confirmData.reasonOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
          @if (!confirmData.selectedReason) {
            <p class="sz-form-error">Reason is required</p>
          }
        </div>
      </div>
      @if (confirmData.selectedReason === 'other') {
        <div class="field w-full mt-3">
          <div class="field-label">Please specify:</div>
          <div class="field-value">
            <textarea class="sz-input" rows="3" [(ngModel)]="confirmData.reasonNote"
                      placeholder="Enter your reason"></textarea>
          </div>
        </div>
      }
    }
    @if (confirmData.includeFiles) {
      <div class="flex flex-row flex-wrap w-full h-[100px]">
        @for (file of confirmData.files; track file) {
          <div class="mb-1 mr-2 mt-2">
            <!-- show file icon or background image by file extension -->
            <div class="border rounded-lg hover:shadow-md transition-shadow cursor-pointer mb-1 w-[55px] h-[60px] flex items-center justify-center">
              <img src="../../../../assets/icons/file.svg" [width]="28" [height]="28" alt="file icon" />
            </div>
            <p>{{file.name | slice:0:2}}...{{file.name.split('.').pop()}}</p>
          </div>
        }
        <div class="mb-1 mr-2 mt-2 flex flex-col">
          <input id="file-upload" hidden multiple type="file" (change)="handleFileChange($event)" />
          <div class="border border-dashed rounded-lg hover:shadow-md transition-shadow cursor-pointer mb-1 w-[55px] h-[60px] flex items-center justify-center"
                (click)="triggerFileUpload()">
            <div class="flex items-center justify-center gap-2 text-primary">
              <i class="fa-solid fa-plus"></i>
            </div>
          </div>
        </div>
      </div>
    }
</app-confirm-modal>

<app-side-nav-outer-toolbar title="{{appInfo.title}}">
  <router-outlet></router-outlet>
</app-side-nav-outer-toolbar>
